/** @flow */
import * as Paths from "./constants";

export const route = <K: $Keys<typeof Paths>>(route: K, params?: Object) => {
  let result = Paths[route] || route;
  for (const prop in params) {
    const regex = new RegExp(`:${prop}\\??`);
    result = result.replace(regex, params[prop]);
  }
  return result;
};

export const goToExternalUrl = (path: string, inNewWindow?: boolean): Object => {
  if (inNewWindow) {
    return window.open(path, "_blank");
  } else {
    window.location.href = path;
    return {};
  }
};
